import { Animation } from './Animation'
import uploadingData from './data/uploading.json'
import { LottieProps } from 'react-lottie-player'

const Uploading = (props: LottieProps) => <Animation {...props} animationData={uploadingData} />

export default Uploading
